import axios from "axios";
import { config } from "../../Utils/helpers";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const changePassword = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "CHANGE_PASSWORD_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/admin/reset-password`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({ type: "CHANGE_PASSWORD_SUCCESS", payload: data });
                return { success: true };
            } else {
                dispatch({ type: "CHANGE_PASSWORD_FAILURE", payload: data });
                return { success: false };
            }
        } catch (error) {
            dispatch({
                type: "CHANGE_PASSWORD_FAILURE",
                payload: error.response?.data || { message: "Something went wrong" },
            });
            return { success: false };
        }
    };
};